import React from 'react';
import ImageUpload from '../imageUpload';
import Hamburger from '../buttons/Hamburger';

function Update() {
  return (
    <div className="page">
      <Hamburger />
      <div className="card-wide">
        <h1 className="heading-hero mb-2 text-center">デッサン画像アップロード</h1>
        <p className="text-subtitle mb-4 text-center">デッサン画像をアップロードしてください。</p>
        <ImageUpload />
      </div>
    </div>
  );
}

export default Update;